module.exports = __webpack_public_path__ + "static/media/play-stream-svgrepo-com.a280992e.svg";